import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import campaDebito from '../../general/campaDebito/index.vue'
import cambioPass from '../../general/cambioPass/index.vue'

import widgets from './widgets/widgets.vue'
import tventas from './tventas/tventas.vue'


export default {
  name: 'pagos',
  data() {
    return {
      msg: '-'
    }
  },

  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
  },
  computed: {
    currentdate: function () {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return dd + '/' + mm + '/' + yyyy;
    }
  },
  components: {
    campaDebito,
    barra,
    barrais,
    widgets,
    tventas,
    barrade,
    cambioPass
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/pagos/pagos.js